import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { IonAlert, isPlatform } from '@ionic/react';
import { useEffect, useState } from 'react';

import { requestVersionControl } from '@/services/api/version';
import { RootState } from '@/store';
import { useDispatch, useSelector } from 'react-redux';
import { VersionControl } from '@/interfaces/VersionControlInterface/VersionControlInterface';
import { saveVersionControl } from '@/redux/configOptions/config';

export default function VersionAlert() {
  const [isOpen, setIsOpen] = useState(false);
  const [versionControl, setVersionControl] = useState<VersionControl>();
  const [showEstrictUpdateAlert, setShowEstrictUpdateAlert] = useState(false);
  const checkVersionControlData = useSelector(
    (state: RootState) => state.configSlice.versionControl,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (Capacitor.isNativePlatform() && !versionControl) {
      // if (!versionControl) {
      if (!checkVersionControlData) {
        requestVersionControl().then((res) => {
          const versionRes = res as VersionControl;
          setVersionControl(versionRes);
          App.getInfo().then((version) => {
           // console.log(version, versionRes);
            if (parseFloat(version.build) < parseFloat(versionRes.minimal_version.version_number)) {
              setShowEstrictUpdateAlert(true);
              setIsOpen(true);
            } else if (
              parseFloat(version.build) < parseFloat(versionRes.newest_version.version_number)
            ) {
              setIsOpen(true);
            }
          });
          dispatch(saveVersionControl(versionRes));
        });
      } else {
        setVersionControl(checkVersionControlData);
        App.getInfo().then((version) => {
          if (parseFloat(version.build) < parseFloat(checkVersionControlData.minimal_version.version_number)) {
            setShowEstrictUpdateAlert(true);
            setIsOpen(true);
          } else if (
            parseFloat(version.build) < parseFloat(checkVersionControlData.newest_version.version_number)
          ) {
            setIsOpen(true);
          }
        });
      }
    }
  }, [versionControl]);

  const openStore = () => {
    if (isPlatform('ios')) {
      window.open(versionControl?.apple_store_link, '_blank');
    } else {
      window.open(versionControl?.google_store_link, '_blank');
    }
  };

  return (
    showEstrictUpdateAlert
      ? (
        <IonAlert
          isOpen={isOpen}
          header={versionControl?.minimal_version.title}
          message={versionControl?.minimal_version.message}
          buttons={[
            {
              text: 'Actualizar',
              role: 'confirm',
              handler: () => {
                openStore();
                return false;
              },
            },
          ]}
          backdropDismiss={false}
        />
      )
      : (
        <IonAlert
          isOpen={isOpen}
          header={versionControl?.newest_version.title}
          message={versionControl?.newest_version.message}
          buttons={[
            {
              text: 'Volver',
              role: 'cancel',
              handler: () => true,
            },
            {
              text: 'Actualizar',
              role: 'confirm',
              handler: () => openStore(),
            },
          ]}
          onDidDismiss={() => setIsOpen(false)}
        />
      )
  );
}

